class VolumeControl extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.volume-control__button');
    this.slider = this.querySelector('.volume-control__slider');
    this.fill = this.querySelector('.volume-control__slider-fill');
    this.videoMedia = this.closest('video-media');
    this.previousVolume = 1;

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSliderInput = this.onSliderInput.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onVideoPlay = this.onVideoPlay.bind(this);

    this.button.addEventListener('click', this.onButtonClick);
    this.slider.addEventListener('input', this.onSliderInput);
    this.slider.addEventListener('mousedown', this.onDragStart);
    this.slider.addEventListener('touchstart', this.onDragStart, { passive: true });
    document.addEventListener('mouseup', this.onDragEnd);
    document.addEventListener('touchend', this.onDragEnd);

    this.updateFill();

    if (this.videoMedia) {
      this.videoMedia.addEventListener('video:play', this.onVideoPlay);
    }
  }

  get isMuted() {
    return this.getAttribute('data-muted') === 'true';
  }

  set isMuted(val) {
    this.setAttribute('data-muted', val ? 'true' : 'false');
  }

  getVideoElement() {
    if (!this.videoMedia) return null;
    return this.videoMedia.querySelector('video') || null;
  }

  onVideoPlay() {
    this.syncVolume();
  }

  syncVolume() {
    const video = this.getVideoElement();
    if (video) {
      video.muted = this.isMuted;
      video.volume = parseFloat(this.slider.value);
    }
  }

  onDragStart() {
    this.classList.add('is-dragging');
  }

  onDragEnd() {
    this.classList.remove('is-dragging');
  }

  onButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const video = this.getVideoElement();

    if (this.isMuted) {
      this.isMuted = false;
      const restoreVolume = this.previousVolume > 0 ? this.previousVolume : 1;
      this.slider.value = restoreVolume;
      if (video) {
        video.muted = false;
        video.volume = restoreVolume;
      }
    } else {
      this.previousVolume = parseFloat(this.slider.value) || 1;
      this.isMuted = true;
      this.slider.value = 0;
      if (video) {
        video.muted = true;
        video.volume = 0;
      }
    }

    this.updateFill();
  }

  onSliderInput() {
    const val = parseFloat(this.slider.value);
    const video = this.getVideoElement();

    if (val === 0) {
      this.isMuted = true;
      if (video) {
        video.muted = true;
        video.volume = 0;
      }
    } else {
      this.isMuted = false;
      this.previousVolume = val;
      if (video) {
        video.muted = false;
        video.volume = val;
      }
    }

    this.updateFill();
  }

  updateFill() {
    const val = parseFloat(this.slider.value);
    const pct = val * 100;
    this.fill.style.height = `${pct}%`;
    this.fill.style.width = '';
  }
}

if (!customElements.get('volume-control')) {
  customElements.define('volume-control', VolumeControl);
}
